import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
//import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig, msalConfigTEST } from './authConfig';

import { Provider } from 'react-redux';
import { createStore } from 'redux';
import appReducer from './reducers';
import moment from 'moment';


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
//const root = createRoot(rootElement);

//const msalInstance = new PublicClientApplication(msalConfig);

let msalInstance;
if (window.location.host == "underthehood.hood.edu") {
    msalInstance = new PublicClientApplication(msalConfig);
}
else { msalInstance = new PublicClientApplication(msalConfigTEST) }

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
    }
});

const store = createStore(appReducer)

ReactDOM.render(
//root.render(
    <MsalProvider instance={msalInstance}>
        <Provider store={store} >
  <BrowserRouter basename={baseUrl}>
    <App />
            </BrowserRouter>
        </Provider>
    </MsalProvider>,
  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
